export const formatStatusClassLook = (v) => {
  let statusClass = ''
  switch (v) {
    case 1:
    case 2:
      statusClass = 'warning'
      break
    case 3:
    case 4:
      statusClass = 'danger'
      break
  }
  return statusClass
}
export const formatStatusValue = (v) => {
  let statusClass = ''
  switch (v) {
    case 1:
      statusClass = '低危'
      break
    case 2:
      statusClass = '中危'
      break
    case 3:
      statusClass = '高危'
      break
    case 4:
      statusClass = '严重'
      break
  }
  return statusClass
}
export const formatVulStatusValue = (feedback, status) => {
  let statusClass = ''
  if (feedback == 0 && status == 0) {
    statusClass = '未处理'
  } else if (feedback == 1 && status == 0) {
    statusClass = '处理中'
  } else if (status == 1) {
    statusClass = '已确认'
  } else if (status == 2) {
    statusClass = '已忽略'
  } else if (status == 3) {
    statusClass = '已修复'
  }
  return statusClass
}
export const formatVulStatusLook = (feedback, status) => {
  let statusClass = ''
  if (feedback == 0 && status == 0) {
    statusClass = 'danger'
  } else if (feedback == 1 && status == 0) {
    statusClass = 'primary'
  } else if (status == 1) {
    statusClass = 'warning'
  } else if (status == 2) {
    statusClass = 'default'
  } else if (status == 3) {
    statusClass = 'info'
  }
  return statusClass
}
